// extracted by mini-css-extract-plugin
export default {"root":"RFMppJr","loading":"g14hZNJ"};